import React, { useContext, Suspense } from 'react';
import DynamicLayout from '../components/DynamicLayout';
import { PlatformContext } from '../context/PlatformContext';
import { MobileComponents, DesktopComponents, LoadingComponent } from '../helpers/platformUtils';
import NoIndexHelmet from '../components/NoIndexHelmet';

const Profile = () => {
  const { platform, loading } = useContext(PlatformContext);
  
  if (loading) {
    return (
      <DynamicLayout>
        <NoIndexHelmet title="Profile | Saturnalia" />
        <LoadingComponent />
      </DynamicLayout>
    );
  }

  const isMobile = platform === 'mobileApp' || platform === 'mobileWeb';
  const MobileComponent = MobileComponents.Profile;
  const DesktopComponent = DesktopComponents.Profile;

  return (
    <DynamicLayout>
      <NoIndexHelmet title="Profile | Saturnalia" />
      <Suspense fallback={<LoadingComponent />}>
        {isMobile ? (
          <MobileComponent />
        ) : (
          <div
            className="full-screen-image-container margin-top-0"
            style={{
              backgroundImage: 'linear-gradient(165deg, #3a0f1d 0%, #2b0b16 45%, #1a060c 100%)',
            }}
          >
            <div className="has-text-centered">
            </div>
            <DesktopComponent />
          </div>
        )}
      </Suspense>
    </DynamicLayout>
  );
};

export default Profile;
